import { Pipe, PipeTransform } from '@angular/core';
import { AppTextService } from '@fi-shared/app-text';
import { fiBasicUsageChargeTypeName } from '../customer-billing-customer/basic-usage-charge-type';

@Pipe({
    name: 'fiBasicUsageChargeTypeName',
    standalone: false,
})
export class BasicUsageChargeTypeNamePipe implements PipeTransform {
    constructor(private appText: AppTextService) {}

    transform(value: any, args?: any): any {
        return fiBasicUsageChargeTypeName(value, this.appText);
    }
}
